import React, { useState } from 'react'
import classNames from 'classnames'
import ExpandMore from '@material-ui/icons/ExpandMore'

export default ({
	classes, messageId, getCommentReplies, text, setRepliesOpen, isHideButton, hasReplies,
}) => {
	const [repliesLastKey, setRepliesLastKey] = useState()
	return (
		<button
			type="button"
			className={classes.viewMoreButton}
			onClick={async () => {
				if (isHideButton) {
					setRepliesOpen(false)
				} else {
					setRepliesOpen(true)
					if (!hasReplies) {
						const lastKey = await getCommentReplies({
							parentId: messageId, lastKey: repliesLastKey,
						})
						setRepliesLastKey(lastKey)
					}
				}
			}}
		>
			<ExpandMore
				className={classNames(
					classes.viewMoreIcon,
					{ [classes.viewMoreIconOpen]: isHideButton },
				)}
			/>
			{text}
		</button>
	)
}
